<template>
  <section class="service-area responsive-content avivon-service rg-bottom-area-padding text-center service-page-2">
    <div class="service-fluid">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-offset-4 col-md-4 col-xs-12">
            <label for="prestamos" class="bold mb-2">Selecciona el tipo de crédito</label>
            <select name="prestamos" placeholder="Tipo de créditos" class="form-control picker shadow" @change="getCuitfReport(reportTypeSelected)" v-model.lazy="reportTypeSelected">
              <option v-for="reportType in reportTypesList" :value="reportType.value" v-bind:key="reportType.value">{{ reportType.text }}</option>
            </select>
          </div>
          <div class="col-xs-12 my-5">
              <h4 class="second__title text-center">
                Información acumulada con cifras al cierre de cada trimestre
              </h4>
              <div class='table-responsive my-5'>
                <table role="table" aria-busy="false" class="table table-striped">
                  <caption aria-hidden="true" v-if="false">Información acumulada con cifras al cierre de cada trimestre</caption>
                  <thead>
                    <tr>
                      <th scope="col"></th>
                      <th scope="col" v-for="report,i in allReports" :key="i">{{report.date_formated}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style="width:50%" class="bold">Monto acumulado de financiamientos otorgados desde el inicio de operaciones</td>
                      <td class="text-align" v-for="report,i in allReports" :key="i">{{explicitMoneyFormatTrunc(report.monto_acumulado_financiamientos)}}</td>
                    </tr>
                    <tr>
                      <td class="bold">Número acumulado de financiamientos otorgados desde el inicio de operaciones</td>
                      <td class="text-align" v-for="report,i in allReports" :key="i">{{intDigitsFormat(report.num_acumulado_financiamientos)}}</td>
                    </tr>
                    <tr>
                      <td class="bold">Número de Solicitantes de financiamiento activos</td>
                      <td class="text-align" v-for="report,i in allReports" :key="i">{{intDigitsFormat(report.solicitantes_activos)}}</td>
                    </tr>
                    <tr>
                      <td class="bold">Número de Solicitantes de financiamiento activos (Personas Físicas)</td>
                      <td class="text-align" v-for="report,i in allReports" :key="i">{{intDigitsFormat(report.solicitantes_activos_pfisicas)}}</td>
                    </tr>
                    <tr>
                      <td class="bold">Número de Solicitantes de financiamiento activos (Personas Morales)</td>
                      <td class="text-align" v-for="report,i in allReports" :key="i">{{intDigitsFormat(report.solicitantes_activos_pmorales)}}</td>
                    </tr>
                    <tr>
                      <td class="bold">Número de Inversionistas activos</td>
                      <td class="text-align" v-for="report,i in allReports" :key="i">{{intDigitsFormat(report.inversionistas_activos)}}</td>
                    </tr>
                    <tr>
                      <td class="bold">Número de Inversionistas activos (Personas Físicas)</td>
                      <td class="text-align" v-for="report,i in allReports" :key="i">{{intDigitsFormat(report.inversionistas_activos_pfisicas)}}</td>
                    </tr>
                    <tr>
                      <td class="bold">Número de Inversionistas activos (Personas Morales)</td>
                      <td class="text-align" v-for="report,i in allReports" :key="i">{{intDigitsFormat(report.inversionistas_activos_pmorales)}}</td>
                    </tr>
                    <tr>
                      <td class="bold">Monto de financiamientos vigentes</td>
                      <td class="text-align" v-for="report,i in allReports" :key="i">{{explicitMoneyFormatTrunc(report.monto_financiamientos_vigentes)}}</td>
                    </tr>
                    <tr>
                      <td class="bold">Número de financiamientos vigentes</td>
                      <td class="text-align" v-for="report,i in allReports" :key="i">{{intDigitsFormat(report.num_financiamientos_vigentes)}}</td>
                    </tr>
                    <tr>
                      <td class="bold">Monto de financiamientos en incumplimiento</td>
                      <td class="text-align" v-for="report,i in allReports" :key="i">{{explicitMoneyFormatTrunc(report.monto_financiamientos_incumplimiento)}}</td>
                    </tr>
                    <tr>
                      <td class="bold">Número de financiamientos en incumplimiento</td>
                      <td class="text-align" v-for="report,i in allReports" :key="i">{{intDigitsFormat(report.num_financiamientos_incumplimiento)}}</td>
                    </tr>
                    <tr>
                      <td class="bold">Porcentaje que representa el monto de financiamientos en incumplimiento respecto del total de financiamientos</td>
                      <td class="text-align" v-for="report,i in allReports" :key="i">{{decimalPercentFormat(report.prcent_financiamientos_inclumplimiento_total, 2)}}</td>
                    </tr>
                    <tr>
                      <td class="bold">Monto de financiamientos en incumplimiento por más de 90 días</td>
                      <td class="text-align" v-for="report,i in allReports" :key="i">{{explicitMoneyFormatTrunc(report.monto_financiamientos_incumplimiento_90d)}}</td>
                    </tr>
                    <tr>
                      <td class="bold">Número de financiamientos en incumplimiento por más de 90 días</td>
                      <td class="text-align" v-for="report,i in allReports" :key="i">{{intDigitsFormat(report.num_financiamientos_incumplimiento_90d)}}</td>
                    </tr>
                    <tr>
                      <td class="bold">Monto de financiamientos en cobranza</td>
                      <td class="text-align" v-for="report,i in allReports" :key="i">{{explicitMoneyFormatTrunc(report.monto_financiamientos_cobranza)}}</td>
                    </tr>
                    <tr>
                      <td class="bold">Número de financiamientos en cobranza</td>
                      <td class="text-align" v-for="report,i in allReports" :key="i">{{intDigitsFormat(report.num_financiamientos_cobranza)}}</td>
                    </tr>
                    <tr>
                      <td class="bold">Rendimiento promedio anual de los financiamientos</td>
                      <td class="text-align" v-for="report,i in allReports" :key="i">{{decimalPercentFormat(report.rendimiento_financiamientos_otorgados, 2)}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <h4 class="second__title text-center">
                Información del periodo reportado con cifras al cierre de cada trimestre
              </h4>
              <div class='table-responsive my-5'>
                <table role="table" aria-busy="false" class="table table-striped">
                  <caption aria-hidden="true" v-if="false">Información del periodo reportado con cifras al cierre de cada trimestre</caption>
                  <thead>
                    <tr>
                      <th scope="col"></th>
                      <th scope="col" v-for="report,i in allReports" :key="i">{{report.date_formated}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style="width:50%" class="bold">Monto de financiamientos en incumplimiento por más de 30 días durante el periodo reportado</td>
                      <td class="text-align" v-for="report,i in allReports" :key="i">{{explicitMoneyFormatTrunc(report.monto_financiamientos_incumplimiento_30d)}}</td>
                    </tr>
                    <tr>
                      <td class="bold">Número de financiamientos en incumplimiento por más de 30 días durante el periodo reportado</td>
                      <td class="text-align" v-for="report,i in allReports" :key="i">{{intDigitsFormat(report.num_financiamientos_incumplimiento_30d)}}</td>
                    </tr>
                    <tr>
                      <td class="bold">En su caso, monto recuperado de financiamientos en incumplimiento por más de 90 días durante el periodo reportado</td>
                      <td class="text-align" v-for="report,i in allReports" :key="i">{{explicitMoneyFormatTrunc(report.monto_recuperado_financiamientos_90d)}}</td>
                    </tr>
                    <tr>
                      <td class="bold">En su caso, porcentaje que representa el monto recuperado durante el periodo reportado, respecto del Monto de financiamientos en incumplimiento por más de 90 días</td>
                      <td class="text-align" v-for="report,i in allReports" :key="i">{{decimalPercentFormat(report.prcent_monto_recuperado_90d, 2)}}</td>
                    </tr>
                    <tr>
                      <td class="bold">Monto de nuevos financiamientos otorgados durante el periodo reportado</td>
                      <td class="text-align" v-for="report,i in allReports" :key="i">{{explicitMoneyFormatTrunc(report.monto_nuevos_financiamientos_trimestre)}}</td>
                    </tr>
                    <tr>
                      <td class="bold">Número de nuevos financiamientos otorgados durante el periodo reportado</td>
                      <td class="text-align" v-for="report,i in allReports" :key="i">{{intDigitsFormat(report.num_nuevos_financiamientos_trimestre)}}</td>
                    </tr>
                    <tr>
                      <td class="bold">Monto de los financiamientos liquidados durante el periodo reportado</td>
                      <td class="text-align" v-for="report,i in allReports" :key="i">{{explicitMoneyFormatTrunc(report.monto_financiamientos_liquidados_trimestre)}}</td>
                    </tr>
                    <tr>
                      <td class="bold">Número de financiamientos liquidados durante el periodo reportado</td>
                      <td class="text-align" v-for="report,i in allReports" :key="i">{{intDigitsFormat(report.num_financiamientos_liquidados_trimestre)}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p style="font-size: 14px;" class="text-start">
                <strong>Donde:</strong><br>
                <!-- <strong>t:</strong> trimestre más reciente que se reporta, con cifras al cierre de marzo, junio, septiembre y diciembre. <br>
                <strong>t – 1:</strong> trimestre inmediato anterior al que se reporta. <br> -->
                <strong>Solicitantes de financiamiento activos:</strong> número de Solicitantes que tienen un financiamiento en el periodo reportado. <br>
                <strong>Inversionistas activos:</strong> número de Inversionistas que son acreedores en el periodo reportado. <br>
                <strong>Monto de financiamientos vigentes:</strong> incluye el saldo total insoluto de los financiamientos que se encuentran al corriente en sus pagos, tanto de principal como de intereses, de acuerdo a la calendarización de pagos programada y convenida al pactar la Operación.<br>
                <strong>Número de financiamientos vigentes:</strong> incluye el número total de los financiamientos que se encuentran al corriente en sus pagos, 
                tanto de principal como de intereses, de acuerdo a la calendarización de pagos programada y convenida al pactar la Operación. <br>
                <strong>Monto de financiamientos en incumplimiento:</strong> incluye el saldo total de aquellos financiamientos en los que el Solicitante no ha cubierto 
                el pago total de principal y/o intereses comprometidos de acuerdo a la calendarización de pagos programada y convenida 
                al pactar la Operación. <br>
                <strong>Número de financiamientos en incumplimiento:</strong> incluye el número total de los financiamientos en los que el Solicitante no ha cubierto 
                el pago total de principal y/o intereses comprometidos de acuerdo a la calendarización de pagos programada y convenida 
                al pactar la Operación. <br>
                <strong>Número total de financiamientos:</strong> Número de financiamientos vigentes + Número de financiamientos en incumplimiento.
              </p>
          </div><!-- col -->
        </div><!-- row -->
      </div><!-- container -->
    </div><!-- end service-fluid -->
  </section>
</template>

<script>
import formatHelper from "@mixins/formatHelper";
export default {
  name: "RC17Numbers",
  mixins: [formatHelper],
  data() {
    return {
      reportTypeSelected: 1,
      reportTypesList:[
          {text:'Crédito personal',value:1},
          {text:'Crédito empresarial',value:2},
      ],
      allReports:[]
    }
  },
  async beforeMount(){
    await this.getCuitfReport(1);
  },
  methods: {
    async getCuitfReport(reportType){
      try {
        this.reportTypeSelected = reportType;
        const res = await this.publicApiGet('/api/v1/public_stats/cuitf17/'+this.reportTypeSelected);
        this.allReports = res.data.reports;
        this.setReportData();
      }
      catch (e) {
      }
    },
    setReportData(){
      this.allReports.forEach(report => {
        let date = new Date(report.report_date);
        let date_formated = '-';
        switch (true) {
          case (0<=date.getMonth()&&date.getMonth()<3):
            date_formated = 'Ene-Mar';
            break;
          case (3<=date.getMonth()&&date.getMonth()<6):
            date_formated = 'Abr-Jun';
            break;
          case (6<=date.getMonth()&&date.getMonth()<9):
            date_formated = 'Jul-Sep';
            break;
          case (9<=date.getMonth()&&date.getMonth()<12):
            date_formated = 'Oct-Dic';
            break;
        }
        date_formated += ` ${date.getFullYear()}`;
        report.date_formated = date_formated;
      });
    }
  },
}
</script>

<style scoped>
  .text-align {
    text-align: left;
  }
  .picker {
    margin-bottom: 20px;
    padding:16px 25px;
    height: auto;
  }
</style>